import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { Container, Button, Row, Form, Col} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { activeUser, sendVerificationCode } from '../../actions/usersActions'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'

export default function Activation() {     
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { idUser } = useParams()
    const {user, resultuser} = useSelector(state=>state.users)

    const [active_code, setActivationcode] = useState(false)
    const [sendVerify, setSendVerify] = useState(false)
    
    const ActiveCodeChange = ({target})=>{
        setActivationcode(target.value)
    }

    const activate = async(e) => {
        e.preventDefault()

        dispatch(activeUser(idUser, active_code))
    }

    const sendCode = async(e) => {
        e.preventDefault()
        setSendVerify(true)
        dispatch(sendVerificationCode(idUser))
    }

    useEffect(() => {
    }, [user, dispatch])

    useEffect(() => {
        if(resultuser){
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('users.gotologin'),
                        icon: 'success',
                        text: t('users.verified')
                    }).then((resultuser) => {
                        if (resultuser.isConfirmed) {
                            navigate('/')
                        }
                    })
                    break;
                case 'wrongcode':
                    Swal.fire({
                        showConfirmButton: true,
                        confirmButtonText: t('users.tryagain'),
                        icon: 'error',
                        text: t('users.wrongcode')
                    })
                    break;
                case 'emailsended':
                    Swal.fire({
                        showConfirmButton: true,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('users.emailsended')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    return (
        <Container fluid>
            <Row>
                <Col xs={12} className='py-4'>
                    <div id="logotipo-auth" className='text-center text-md-start px-3 pb-5'><Link to="/login"><img src="/images/logotipo-skill.svg" alt="Logotipo skillconnectED" /></Link></div>
                    <Container className='p-0 py-5 p-md-5'>
                        <Row>
                            <Col className='px-5 text-center mb-4'>
                                <h1>{t('users.active_code')}</h1>
                                <div>
                                    {t('users.messageemail')}
                                </div>
                                <div>
                                    {t('users.messagespan')}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={10} md={8} lg={5} className='mx-auto my-3'>
                                <Form className="p-4 formulario">
                                    <Row className="text-center my-3">
                                        <Col>
                                            <Form.Control
                                                type='text'
                                                name='active_code' 
                                                value={active_code ||  ''}                                                
                                                onChange={ActiveCodeChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="text-center my-3">
                                        <Col>
                                            <Button variant='primary' type="submit" className="w-100 my-2" onClick={activate}>{t('users.verify')}</Button>
                                        </Col>
                                    </Row>
                                    <Row className="text-center my-3">
                                        <Col>
                                            <Button variant='default' type="submit" className="w-100 my-2" onClick={sendCode}>{t('users.sendverify')}</Button>
                                            <small>{sendVerify ? t('users.emailsendedbutton') : ''}</small>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </Container>
    )
}
